export default {
sets: `Kompleti`,
stats: `Statistika`,
discover: `Odkrijte`,
guides: `Vodniki`,
settings: `Nastavitve`,
unsupportedBrowserBody: `Flashcards ne podpira tega brskalnika. Prenesite najnovejšo različico Chrome ali Opera ali prenesite našo iPhone ali Android Application`,
unsupportedBrowserTitle: `Nepodprt brskalnik`,
noData: `Ni podatkov, ki bi ga pokazali`,
contactUsTitle: `Radi slišimo, kako naši uporabniki uporabljajo našo aplikacijo in kako se lahko izboljšamo. Spustite nam sporočilo s poizvedbami, kot so zahteve za funkcije ali poročila o napakah`,
rateAppStore: `Ocena v AppStore`,
rateGoogle: `Ocena v Google Play`,
close: `Blizu`,
shareFriends: `Deli s prijatelji`,
noCardsQ: `Nimate nobenih kartic?`,
noCardsS: `Izberite iz naše zbirke, da začnete`,
suggestSet: `Predlagajte nastavitev`,
createOwn: `Ustvarite svoje`,
search: `Iskanje`,
loading: `nalaganje`,
words: `Besede`,
downloads: `Prenosi`,
export: `Izvoz`,
import: `Uvoz`,
importing: `Uvoz ... ne zapirajte aplikacije`,
importPreview: `Uvozni predogled`,
howQuizlet: `Kako uvoziti iz kviza`,
cards: `Kartice`,
importPreviewStatus: `__ Pogoji so pripravljeni na obstoječe ___ kartice`,
importPaste: `Svoje kartice prilepite v zgornjo besedilo`,
setTotalLimitReached: `V studentu lahko imate samo 3000 kart`,
studying: `Študij`,
learnt: `Naučil`,
mastered: `Obvladano`,
new: `Novo`,
noTerm: `Brez izraza`,
noDef: `Brez definicije`,
cardSaved: `Kartica shranjena`,
reviews: `Ocene`,
practices: `Vaje`,
flashcards: `Kartice`,
alerts: `Opozorila`,
corrects: `Popravi`,
mistakes: `Napake`,
reviewCycle: `Pregled cikla`,
reviewsLeft: `Ocene so ostale`,
lastReview: `Zadnji pregled`,
nextReview: `Naslednji pregled`,
hideHistory: `Skrij polno zgodovino`,
showHistory: `Pokaži polno zgodovino`,
strength: `Moč`,
star: `zvezda`,
image: `Slika`,
tag: `Oznaka`,
added: `dodan`,
removed: `odstranjeno`,
reviewedFrom: `Pregledan od __`,
notifications: `Obvestila`,
reviewedPractice: `Pregledal __ s ___ prakso`,
successfully: `uspešno`,
unsuccessfully: `neuspešno`,
termUpdated: `Izraz posodobljen`,
defUpdated: `Definicija posodobljena`,
flashcardCreated: `Ustvarjena flashcard`,
dropboxImage: `Za dodajanje slik morate omogočiti Dropbox Sync`,
deleteImgConfirm: `Ali ste prepričani, da želite izbrisati to sliko?`,
uploading: `Nalaganje`,
save: `Shrani`,
uploadImageFail: `Ni uspelo naložiti slike`,
imageUploaded: `Slika naložena`,
setNotFound: `Studyt ni mogoče najti!`,
notEnoughCards: `Ni dovolj kart!`,
of: `__ od ___`,
on: `Naprej`,
off: `OFF`,
auto: `Samodejno`,
manual: `Ročno`,
pronounce: `Izgovoriti`,
practiceCompleted: `Ste zaključili to prakso`,
closePractice: `Tesna praksa`,
autoplay: `Samodejno predvajanje`,
secFlipSecNext: `__ sek flip, ___ sek naslednji`,
autopronounce: `AutoPronounce`,
onlyTerm: `Samo izraz`,
onlyDef: `Samo definicija`,
termAndDef: `Izraz in definicija`,
savePractice: `Shrani prakso?`,
continueLater: `Nadaljujte kasneje`,
deletePractice: `Izbrišite prakso`,
term: `Izraz`,
def: `Opredelitev`,
monA: `M`,
tueA: `T`,
wedA: `W`,
thuA: `T`,
friA: `F`,
satA: `S`,
sunA: `S`,
reviewGoal: `Pregled cilja`,
dailyGoal: `Dnevni cilj`,
edit: `Uredi`,
setUp: `Nastaviti`,
noRecentPractice: `Nimate nobenih nedavnih praks`,
continueLastReview: `Nadaljujte zadnji pregled`,
dueCards: `Za ustrezne kartice`,
studyNow: `Študij zdaj`,
newCards: `Nove kartice`,
terms: `izrazi`,
defs: `definicije`,
validCardsOf: `Vaditi je mogoče samo __ izbranih ___ kartic, saj ostale manjkajo ali definicija`,
reviewCards: `Kartice za pregled`,
customizePractice: `Prilagodite prakso`,
next: `Naslednji`,
iWasRight: `prav sem imel`,
printProAlert: `Prosimo, da kupite naročnino za tiskanje več kot 20 kartic`,
print: `Tisk`,
printWidth: `Term-def širina`,
printFont: `Velikost pisave`,
printBorder: `Mejo`,
printMargin: `Marža strani`,
printPadding: `Besedno oblazinjenje`,
preparingFile: `Priprava datoteke`,
notificationsBlocked: `Obvestila niso omogočena, omogočite obvestila iz nastavitev telefona`,
ranOutOfWords: `Zmanjkalo kartic, znova zaženite prakso, da začnete znova`,
ranOutOfWordsShort: `Zmanjka besed`,
ranOutOfWordsBody: `Odprite aplikacijo za načrtovanje novih besed`,
proIncreaseNotifications: `Skupna obvestila lahko povečate z 10 na 50 v premijski različici.`,
schedule: `Urnik`,
frequency: `Frekvenca`,
mode: `Način`,
tM1: `1 minuta`,
tM2: `2 minuti`,
tM5: `5 minut`,
tM10: `10 minut`,
tM15: `15 minut`,
tM30: `30 minut`,
tH1: `1 uro`,
tH2: `2 uri`,
termPassive: `Izraz pasiven`,
termActive: `Izraz aktiven`,
defPassive: `Def pasivno`,
defActive: `Def aktivno`,
scheduledIn: `Načrtovano v __ minut`,
scheduledAlertsProT: `Povečajte si opozorila, ki jih je mogoče načrtovati s Pro`,
scheduledAlertsProB: `S paketom Pro paket lahko povečate načrtovana opozorila z 10 na 50`,
seeFeatures: `Glej funkcije`,
defAndTerm: `Definicija in izraz`,
termHoldDef: `Izraz, zadržite, da razkrijete definicijo`,
defHoldTerm: `Opredelitev, zadržite, da razkrijete izraz`,
notificationType: `Vrsta obvestila`,
copyToClipboard: `Kopirati v odložišče`,
enterAuthCode: `Prosimo, vnesite svojo kodo za avtorizacijo`,
invalidCode: `Navedena neveljavna koda`,
copied: `Kopirano!`,
promoH2: `Flashcard Manager Pro`,
promoP: `Tapnite, da odkrijete vse vrhunske funkcije, če želite učinkoviteje izvedeti v svojem tempu`,
promoBtn: `Odkrijte vse funkcije`,
setDropboxH2: `DropBox Sync`,
setDropboxPOff: `Omogoči Dropbox Sync, da ohranite svoje komplete, kartice, oznake in napredek varnostno kopirano in posodobljeno v vseh vaših napravah.`,
setDropboxPOn: `Vaši podatki so varnostno kopirani in sinhronizirani po vaših napravah.`,
setDropboxBtn: `Sinhronizacija`,
status: `Stanje`,
syncNow: `Sinhronizacija zdaj`,
contact: `Stik`,
contactUs: `Kontaktiraj nas`,
useFromBrowser: `Uporaba iz brskalnika`,
useFromBrowserMsg: `Obiščite flashcardSMadeSimple.com v računalniku in obnovite kartice in licenco, tako da omogočite Dropbox Sync`,
termsPrivacy: `Pogoji in zasebnost`,
dailyReviewGoal: `Dnevni cilj pregleda`,
numberTerms: `Število izrazov`,
selectTerm: `Izberite s Term Hint`,
selectDef: `Izberite z definicijskim namigom`,
pronounceTerm: `Izgovoriti z izrazom`,
pronounceDef: `Izgovoriti z definicijskim namigom`,
typeTerm: `Vrsta z izrazom namig`,
typeDef: `Tip z definicijskim namigom`,
quizTypes: `Prednostne vrste kvizov`,
spacedRepetition: `Razširjeni urnik ponovitve`,
spacedRepetitionP: `Razširjeno ponavljanje vam omogoča, da obvladate besede z manj napori, tako da postopno razmaknete čas pregleda. Privzeti razpored je 1-3-7-15-31 dni, vendar lahko nastavite tudi po meri.`,
spacedRepetionScheduleItem: `__ Dnevi po ___ Pregledu (dan ____)`,
atLeastOneSchedule: `Potreben je vsaj en urnik`,
revisionLimitReached: `Dosegli ste največje štetje`,
addReviewSchedule: `Dodajte nov urnik pregleda`,
autoMarkLearnt: `Auto Mark se je naučil po`,
autoMarkMastered: `Auto Mark obvlada`,
tagManager: `Tag Manager`,
delete: `Izbrisati`,
addTag: `Dodaj novo oznako`,
tagDeletionH: `Izbris oznake`,
tagDeletionP: `Ste prepričani, da želite to oznako izbrisati?`,
cancel: `Odpovedati`,
daysAfterLastReview: `Dnevi po zadnjem pregledu`,
linkDropbox: `Povezava DropBox`,
startSync: `Začnite sinhronizirati`,
starred: `Igral`,
images: `Slike`,
tags: `Oznake`,
types: `Vrste`,
activeDays: `Aktivni dnevi`,
inactiveDays: `Neaktivni dnevi`,
longestStreak: `Najdaljši niz`,
dailyGoalsCompleted: `Dnevni cilji so zaključeni`,
dailyGoalsFailed: `Dnevni cilji niso uspeli`,
typePairs: `Tipi pari`,
reviewTypes: `Vrste pregleda`,
typePractice: `Tipa praksa`,
pronouncePractice: `Izgovoriti prakso`,
selectPractice: `Izberite Praktanje`,
notificationReview: `Pregled obvestila`,
flashcardReview: `Pregled flashcard`,
studyset: `Studyt`,
enterStudysetName: `Vnesite ime za svoj student`,
studysetName: `Vnesite ime set`,
termType: `Term vrsta / Lang`,
defType: `Vrsta definicije / Lang`,
exportCards: `Izvozne kartice`,
importCards: `Uvozne kartice`,
quiz: `Kviz`,
showingOutOfCards: `Prikazuje __ od ___ kartic`,
showingAllCards: `Prikazovanje vseh kartic, vnesite zgornjo iskalno vrstico ali tapnite poljubne oznake za filtriranje`,
recording: `Snemanje`,
downloadSet: `Dodaj v moje komplete`,
addNewCard: `Dodaj novo kartico`,
saveStudyset: `Shrani študijski komplet`,
studysetDeletionH: `Brisanje studeta`,
studysetDeletionP: `Ali ste prepričani, da želite izbrisati ta student, to bo tudi izbrisalo vse vsebovane kartice.`,
cardDeletionH: `Izbris kartice`,
cardDeletionP: `Ali ste prepričani, da želite izbrisati to kartico`,
cardLimitReached: `V studentu lahko imate samo 3000 kart`,
limitExceeded: `Omejitev presežena`,
atLeastTenCards: `Dodajte vsaj 10 kart, da začnete s praksami`,
searchInAll: `Iskanje v vseh študijskih nizih`,
noMatch: `Ni zadetka`,
atLeastThreeChars: `Vnesite vsaj 3 znake za iskanje`,
noSets: `Ni kompletov`,
startingSync: `Začetek sinhronizacije`,
noSetsP: `Izberite med spodnjimi možnostmi za začetek`,
startingSyncP: `Vaše podatke dobivamo iz Dropboxa, to lahko traja nekaj časa`,
createNewStudyset: `Ustvari nov stutyset`,
restoreFromBackup: `Obnovi iz varnostne kopije datoteke`,
setStarterPacks: `Studyt Starterpacks`,
selectPracticeType: `Izberite vrsto prakse`,
noDueCards: `Brez ustreznih kartic še, flashcards, ki ste jih pregledali prej`,
noNewCards: `Za študij ni nobenih novih kartic`,
subscriptionH: `Kupite Pro, da boste uživali v vseh funkcijah in za podporo neprekinjenemu razvoju.`,
buyLifetimePro: `Kupite življenjsko dobo za __`,
restorePurchase: `Obnovi nakup`,
termsPrivacyC: `Pogoji in politika zasebnosti`,
licenceShare: `Če ste licenco kupili pri drugi napravi, jo lahko delite s to napravo, tako da omogočite Sync Dropbox na obeh napravah`,
enterTagName: `Vnesite ime oznake`,
invalidName: `Neveljavno ime`,
create: `Ustvari`,
name: `Ime`,
tagName: `Ime vaše oznake`,
color: `Barva`,
back: `Nazaj`,
rowSeparator: `Separator vrstic`,
termDefSeparator: `Izraz - def separator`,
output: `Izhod`,
inputCards: `Vhodne kartice`,
review: `Pregled`,
language: `Jezik`,
archiveReversible: `Arhiv (reverzibilno iz nastavitev)`,
deletePermanent: `Izbriši (nepopravljivo)`,
archivedCards: `Arhivirane kartice`,
masteredCards: `Obvladane kartice`,
due: `Zaradi`,
reviewed: `Pregledan`,
markReviewed: `Mark Pregled`,
markMastered: `Mark obvladana`,
forXYCards: `za __ ___ kartice`,
createdAtSortBy: `Datum nastanka`,
lastReviewedSortBy: `Zadnji datum pregleda`,
reviewCountSortBy: `Število pregledov`,
strengthSortBy: `Moč`,
termSortBy: `Abecedni izraz`,
definitionSortBy: `Abecedni def.`,
ascSortBy: `Vzpona`,
descSortBy: `Spuščanje`,
featureSync: `Preučite karkoli, kjer koli in kadarkoli s svojimi karticami sinhronizirane po vseh vaših napravah`,
featureSpacedrepetition: `Poiščite svoj splošni napredek in se vrnite k prakticiranju tega, kar morate vaditi`,
featureNotifications: `Napolnite svoje učenje, ne da bi aplikacijo sploh odprli s prilagodljivimi obvestili`,
featureFlashcards: `Samodejne kartice, ko so vaše roke ali oči zasedene, vendar imate še vedno neuporabljeno pozornost`,
featureQuiz: `Ujemanje, črkovanje, poslušajte ali izberite, da vadite svoje kartice`,
featureStats: `Pridobite boljši vpogled v svoje kartice in rezultate ter poiščite vse svoje nabore flashcard`,
featureImport: `Nikoli ne bomo shranili nobenih podatkov o vas, vse svoje podatke pa lahko izvozite in uvozite`,
featurePrint: `Naredite nekaj učenja s tiskanjem kartic in naredite svojo lastno učenje`,
splashIntro: `Preučite vse svoje kartice kjer koli v vašem tempu in slogu`,
selectSortOrder: `Vrstni red`,
selectSortProp: `Razvrsti lastnost`,
applyFilters: `Uporabi filtre`,
selectSetType: `Kaj želite vaditi?`,
getStarted: `Začeti`,
tapToUnarchive: `Tapnite kartice, ki jih želite nerodno`,
untitled: `Brez naslova`,
sortHintNew: `Najprej boste videli karte, ki so bile ustvarjene najdlje`,
sortHintDue: `Videli boste kartice, ki so najdlje najdlje`,
sortHintOther: `videli boste karte, ki jih najprej niso preučevali`,
flashcardsWhen: `, ko so vaše roke ali oči zasedene, tudi med poslušanjem glasbe / podcastov`,
notificationsWhen: `, kajti ko ste zunaj in si želite in si želite hitre študijske koščke`,
quizWhen: `, kajti, ko lahko v celoti pozorni na študij, da obvladate svoje kartice`,
features: `Lastnosti`,
ratings: `Ocene`,
notificationDailyCatchUpBody: `Novo: __, zapadlo: ___, študij: ____, naučeno: _____, obvladano: ______`,
notificationDailyCatchUpTitle: `Dnevno ujetje`,
reviewedJN: `Pregledan šele zdaj`,
customUpdated: `Posodobljeno besedilo po meri`,
customTextField: `Sinonime, primeri itd.`,
field: `Polje`,
link: `Povezava`,
backToParentCard: `Nazaj na nadrejeno kartico`,
discard: `Zavržanje`,
failedImageLoad: `Ni uspelo naložiti slike, se prepričajte, da ste povezani z internetom`,
printDIYLabel: `Naredite svojo lastno kreativno nastavitev študija, ki temelji na papirju, delite z nami svoje ustvarjanje in se predstavite v aplikaciji.`,
reviewGraphChart: `Frekvenca pregleda`,
langNotSet: `Jezik ni nastavljen`,
pronouncationLangInfo: `Če želite omogočiti izgovorjavo, morate izbrati izraz in definicijski jezik. Poleg jezikov se bo pojavil znak zvočnika, če vaša naprava podpira ta jezik`,
clearFilters: `Prozoren filter`,
subFreeUnlimited: `Neomejene studente, kartice, prakse, iskanje in sinhronizacija`,
customFields: `Polja po meri`,
subLinks: `Povezave s karticami`,
subPrint: `Natisni / student`,
subNotifications: `Obvestilo, preden morate odpreti aplikacijo`,
subCardsStudysets: `Kartice / student`,
subRevisionCycles: `Cikli revizije po meri`,
subscriptionHEnd: `Nadgradnja na Pro nam pokaže, da se vam zdi, da je naše trdo delo dragoceno, in nam spodbuja in kavo, da še naprej izboljšujemo in ustvarjamo nove neverjetne stvari.`,
subFree: `prost`,
subPro: `Pro`,
guideSpacedRepetition: `Kako deluje razporejeno ponavljanje in vrste prakse`,
guideSearch: `Iskanje in filtriranje`,
guideSync: `Omogoči varnostno kopiranje in sinhronizacijo prek vaših naprav`,
guidePronunciation: `Omogoči izgovorjavo`,
guideImport: `Uvoz kartic iz izstopanja virov`,
guideAccess: `Kdo ima dostop do mojih podatkov?`,
guideData: `Katere podatke zbiramo?`,
guideContact: `Potrebujete pomoč pri čem drugem? Pišite nam`,
arrowStrength: `Nastavite, kako dobro poznate to kartico`,
arrowImage: `Dodajte slike`,
arrowField: `Dodajte dodatna besedilna polja po meri`,
arrowTag: `Priložite oznake`,
arrowStar: `Označite kot najljubši`,
arrowLink: `Povezava do drugih kartic`,
arrowGoal: `Zastavite si cilj vsakodnevne preglede zase`,
arrowDue: `Študijske besede, ki jih je treba pregledati`,
arrowNew: `Študijske kartice, ki še niso bile pregledane`,
arrowMastered: `Če nimate nobenih zapadlih ali novih kartic, lahko pregledate obvladane kartice, da jih obvladate`,
arrowImport: `Uvozite svoje obstoječe kartice`,
arrowNewCard: `Dodajte nove kartice`,
dropboxStep1: `1. Pridobite dostopno kodo iz Dropboxa z prijavo`,
dropboxStep1Btn: `Prijavite se z Dropboxom`,
dropboxStep2: `2. Spodaj vnesite kodo za dostop`,
dropboxStep2Input: `Vnesite kodo tukaj`,
dropboxStep3: `3. Začnite sinhronizirati`,
alreadyLinked: `Že povezani, tapnite z UNLENK`,
selectCardsToLink: `Izberite kartice za povezavo`,
unsupportedLangP: `Izberite jezik, ki podpira izgovorjavo iz nastavitev nabora`,
links: `Povezave`,
emailUs: `Pošljite nam e -pošto`,
whatsappUs: `Whatsapp nas`,
printMinHeight: `Min. višina vrstice`,
exportType: `Vrsta datoteke izvozi`,
generateFileText: `Ustvari datoteko`,
generatatingFile: `Ustvarjanje datoteke`,
verySmall: `Zelo majhen`,
small: `Majhno`,
normal: `Normalno`,
big: `Velik`,
veryBig: `Zelo velik`,
repeatNTimes: `Ponovite __ krat`,
pause: `Pavza`,
for: `za`,
say: `Reči`,
defShort: `Dejstvo.`,
times: `krat`,
autoplayPreferences: `Nastavite nastavitve samodejnega predvajanja`,
autoPlay1: `Premor po prejšnji besedi`,
autoPlay2: `Število izrazov`,
autoPlay3: `Preprečite, preden razkrijete definicijo`,
autoPlay4: `Število definicijskih izgovorov`,
autoPlay5: `Prepreki, preden prikaže naslednjo besedo`,
autoPlay6: `Ponovite isto flashcard`,
startAutoPlay: `Začnite samodejno igranje`,
autoPlayOffConfirm: `Izklopite samodejno predvajanje, da omogočite ročni nadzor`,
turnOff: `Ugasni`,
keepPn: `Nadaljujte`,
foundIn: `Najdeno v __`,
repeat: `ponoviti`,
stop: `Nehaj`,
listenInBreak: `Ali si vedel? Glasbo / podcaste lahko poslušate v odmorih`,
contextSearch: `Kontekstno iskanje`,
contextSearchText: `Pridobite primere, kako __ uporablja v različnih stavkih`,
transalteSearch: `Prevesti`,
translateSearchText: `Prevede __ na ___`,
synonymSearch: `Iskanje sinonima`,
synonymSearchText: `Iskanje sinonimov __`,
selectToAdd: `Izberite rezultate, ki jih želite dodati na to kartico`,
addToCard: `Dodaj izbran na kartico`,
hideFromPractice: `Skrij se v krogu`,
setLanguageRequired: `Prosimo, izberite jezik izrazov in definicij v podrobnostih studyta`,
fieldNeedsText: `Vnesite nekaj v to polje, preden iščete`,
possibleDupe: `Možni dvojnik`,
loadNextXCards: `Naložite naslednje __ kartice`,
repeatPractice: `Ponovite te __ kartice`,
keepScreenOnInfo: `Morda boste morali prilagoditi svojo nastavitev samodejnega zaklepanja, da bo zaslon vklopljen med samodejnim igranjem.`,
siteLoginH2: `Račun SFM`,
siteLoginP: `S svojimi karticami Made Simple Račun lahko uporabite za delitev kartic s prijatelji, študenti ali celotno skupnostjo.`,
logOut: `Odjava`,
logIn: `Vpiši se`,
createAccount: `Ustvariti nov račun`,
signUp: `Prijavite se`,
username: `Uporabniško ime`,
email: `E-naslov`,
password: `Geslo`,
networkError: `Napaka omrežja`,
fillAllDetails: `Prosimo, izpolnite vse podrobnosti`,
noUserWithDetails: `Nobenega uporabnika ne najdemo z vnesenimi podrobnostmi`,
userAlreadyExists: `Dano e -pošto ali uporabniško ime že obstaja`,
signUpOrLoginToCont: `Prijavite se ali se prijavite za nadaljevanje?`,
atLeastOneCardToShare: `Za skupno rabo je potrebna vsaj ena kartica`,
publishingStudyset: `Založba Studyset`,
updatesDetected: `Odkrite posodobitve, ali želite nadaljevati s posodabljanjem lokalnih podatkov? (Izbrisano: __, posodobljeno: ___, novo: ____)`,
updatesApplied: `Uporabljene posodobitve`,
alreadyUpToDate: `Že na tekočem`,
practiceTypeArrow: `Odkrijte različne načine prašitve`,
share: `Deliti`,
sharingModalIntro: `Delite svoje kartice v tem kompletu s prijatelji, študenti ali celotno skupnostjo.`,
whatIsShared: `Kaj se deli`,
whatIsNotShared: `Kaj ni v skupni rabi`,
whatIsSharedText: `Nastavi ime, nastavljen jezik, jezik definicije, vse vključene kartice s pogoji, definicijami, besedilnimi polji in slikami po meri`,
whatIsNotSharedText: `Vse prednosti kartice, zvezde, povezave, oznake in zgodovina pregleda`,
checkForSharedUpdates: `Preverite posodobitve ustvarjalca`,
fetchUpdates: `Posodobitve`,
youSharedStudyset: `Ste delili ta studet`,
publishChanges: `Shrani in objavi spremembe`,
redeem: `Odkup`,
noAds: `Brez oglasov`,
dupeDetection: `Podvojeno odkrivanje`,
coffeeFeature: `Kava, da nam pomaga razviti več funkcij`,
shareLink: `Skupna povezava`,
coffeeForUs: `Dobili boste licenco za življenjsko dobo samo za __, ki daje Emily 6 Coffees, Dominik 3 Coffees in Russ 3 Coffees, kar nas bo približno 39 ur spodbudilo, da bomo ta dogodek aplikacije izboljšali`,
sharingCards: `Kartice za skupno rabo`,
published: `Objavljeno`,
alreadyHaveAccount: `Že imate račun?`,
notAlreadyHaveAccount: `Še nimate računa?`,
startPractice: `Začetek prakse`,
selectQuizTypes: `Izberite vrste kviza`,
correct: `Pravilno`,
incorrect: `Napačno`,
yes: `DA`,
no: `Ne`,
levelSilver: `Srebrna raven __`,
levelGold: `Raven zlata __`,
levelPlatinum: `Nivo platine __`,
levelDiamond: `Diamantna raven __`,
levelJade: `Jade Level __`,
reviewsLeftGoal: `__ Ocene za dnevni cilj`,
dailyGoalAchieved: `Dnevni doseženi cilj`,
share: `Deliti`,
rateApp: `APP`,
allStats: `Vsi podatki`,
reviewTimeError: `Časovna omejitev po napaki`,
reviewTimeCorrect: `Časovna omejitev po pravilnem`,
pronounceTermAfterReview: `Izgovori izraz po pregledu`,
pronounceDefinitionAfterReview: `Izgovoriti definicijo po pregledu`,
practice: `Vadba`,
notificationsScheduledInfo: `__ Obvestila so načrtovana, aplikacijo lahko zaprete zdaj`,
wellDone: `Dobro opravljeno`,
keepItUp: `Vstrajaj`,
youRock: `Zažigaš`,
niceOne: `Dobra`,
lnSelect: `Izberi jezik`,
sampleData: `Brez pregledov, ki prikazujejo vzorčne podatke`,
reviewFreq: `Frekvenca pregleda`,
selectPractice: `Vadba: izberite`,
spellPractice: `Vadba: črkovanje`,
connectPractice: `Vadba: Povežite se`,
languages: `Jeziki`,
languagesPairs: `Jezikovne pare`,
shareArrow: `Delite s prijatelji, študenti ali celotno skupnost`,
cardsPerRound: `Kartice / krog`,
showAll: `Pokaži vse`,
supportedLangsVary: `Podprti jeziki se razlikujejo`,
practiceWithoutSave: `Praksa ni shranjena`,
practiceWithoutSaveBody: `Tega studenta niste dodali v svojo zbirko, ali ga želite dodati zdaj, da shranite napredek v študiju?`,
saveSetNow: `Shrani kartice za vašo zbirko`,
continueWithoutSaveSave: `Začnite prakso brez shranjevanja`,
createdBy: `Ustvaril`,
setSavedToYourCollection: `Študijski komplet, shranjen v vaši zbirki`,
accountBackupDisclaimer: `Upoštevajte, da se ta račun lahko uporablja samo za skupno rabo student z drugimi in ga ni mogoče uporabiti za varnostno kopiranje ali sinhronizacijo vaših student ali flashcards. Za sinhronizacijo in varnostno kopiranje vseh podatkov uporabite Dropbox Sync`,
syncEnabled: `Omogočena sinhronizacija, ki doseže vašo vsebino v teku`,
searchAllSets: `Iskanje študijskih sklopov drugih uporabnikov`,
anyLanguage: `Kateri koli jezik`,
trendingIn: `Trendin`,
manualBackups: `Ročna varnostna kopija`,
manualBackupCreate: `Ustvari ročno varnostno kopijo`,
confirmManualImport: `Ali ste prepričani, da želite vse trenutne podatke zamenjati s to varnostno kopijo? To je priporočljivo le na novih napravah brez kakršnih koli podatkov`,
importFromManualBackup: `Uvoz iz varnostne kopije`,
imgOfflineSets: `Slike samodejnega nalaganja za učenje brez povezave`,
unsupportedDeviceCache: `Ta funkcija je na voljo samo v aplikaciji iOS ali Android`,
shareChanges: `Delite __ spremembe`,
publiclySearchable: `Iskalni uporabniki`,
description: `Opis`,
restoreFromDropboxBackup: `Obnovite iz varnostne kopije Dropbox`,
imageCacheStudysetSub: `[Samo iOS & Android] Prenesite sliko za študij brez povezave`,
keywordsOrLangNeeded: `Vnesti morate nekaj ključnih besed ali enega jezika`,
dropboxAlreadyLinked: `Dropbox račun je že povezan`,
noSetUpdateAccess: `Nimate dostopa do urejanja tega študijskega niza.`,
confirmSetOwnerLogin: `Če ste prepričani, da ste lastnik, se poskusite znova prijaviti v svoj račun.`,
uninitedRestriction: `Če želite prihraniti svoj napredek, morate v svojo zbirko dodati ta student`,
getStartedHere: `Get Started Here`,
downloadFromAppStore: `Download From AppStore`,
downloadFromGooglePlay: `Download From GooglePlay`,
consolidateStorageError: `Ni uspelo konsolidirati shranjevanja`,
consolidateStorageDone: `Shranjevanje konsolidira, prosimo, pustite do eno uro, da Dropbox konča odstranitev starih datotek, preden se prijavite v novo napravo.`,
consolidatingStorage: `Konsolidacijsko shranjevanje ...`,
deleteAccount: `Izbriši račun`,
consolidateStorageDescription: `Ta operacija bo ponovno vključila datoteke z varnostnimi kopijami, zato bo nastavitev novih naprav hitrejša`,
consolidatingStorageConfirm: `Prepričajte se, da so vse vaše spremembe že končale sinhronizacijo, med tem postopkom ne sinhronizacije drugih naprav. Ali želite nadaljevati?`,
consolidateStorage: `Konsolidirano shranjevanje`,


}